import { toNumber } from 'utils/currency';

export const formatPOAmountForInput = (
  value: number | string | null,
): string => {
  const num = toNumber(value);
  if (num === null) return '';
  return num.toFixed(2);
};

export const parsePOAmount = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  const normalized = trimmed.replace(',', '.');
  const parsed = parseFloat(normalized);
  if (Number.isNaN(parsed)) return null;
  return parseFloat(parsed.toFixed(2));
};

export const parseInvoiceNumber = (raw: string): string | null => {
  const trimmed = raw.trim();
  return trimmed === '' ? null : trimmed;
};
